import { render, staticRenderFns } from "./chartStockDonnut.vue?vue&type=template&id=ab9d7962&"
import script from "./chartStockDonnut.vue?vue&type=script&lang=js&"
export * from "./chartStockDonnut.vue?vue&type=script&lang=js&"
import style0 from "./chartStockDonnut.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports